module.exports = "<!--begin::Footer-->\n<div class=\"footer bg-white py-4 d-flex flex-lg-column\" id=\"kt_footer\">\n  <!--begin::Copyright-->\n  <div class=\"text-dark order-2 order-md-1 d-flex justify-content-end\">\n    <span class=\"font-weight-bold mr-2\">{{$ctrl.currentYear}}©</span>\n    <span class=\"pr-10\">HSS</span>\n  </div>\n  <!--end::Copyright-->\n</div>\n<!--end::Footer-->\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/footer/footer.html
// module id = 460
// module chunks = 0